import Button from '@propertypal/web-ui/src/buttons/Button';
import Card from '@propertypal/web-ui/src/card/Card';
import Tabs from '@propertypal/web-ui/src/tabs/Tabs';
import { SubHeading, Text } from '@propertypal/web-ui/src/typography';
import React, { useState } from 'react';
import { useTheme } from 'styled-components';
import { LoginItem, LoginCardContainer, LoginContent } from '../login/Login.style';
import AgentSignUpForm from './AgentSignUpForm';

const TABS = [
  { key: 'login', text: 'Login' },
  { key: 'signup', text: 'Sign Up' },
];

const EstateAgentInfoFormContainer = () => {
  const theme = useTheme();
  const [tab, setTab] = useState('login');

  return (
    <LoginItem>
      <LoginCardContainer>
        <Card>
          <Tabs tabs={TABS} activeTab={tab} onTabClick={setTab} disableArrows />

          {tab === 'login' && (
            <LoginContent>
              <SubHeading align="center" mb={70}>
                Estate Agents Login
              </SubHeading>

              <Text color={theme.textDark} align="center">
                Existing Estate Agents, go to login page
              </Text>

              <a href="https://client.propertypal.com">
                <Button containerStyle={{ marginTop: '18px', marginBottom: '315px' }}>Login</Button>
              </a>
            </LoginContent>
          )}

          {tab === 'signup' && (
            <LoginContent>
              <AgentSignUpForm />
            </LoginContent>
          )}
        </Card>
      </LoginCardContainer>
    </LoginItem>
  );
};

export default EstateAgentInfoFormContainer;
